






























import { Vue, Component } from "vue-property-decorator";
import Practice from "@/components/practice/Practice.vue";
import api from "@/getinfo-api";
import { Practice as IPractice } from "@/api/models/practice";
import { Course as ICourse } from "@/api/models/course";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import PracticePassResult from "@/components/practice/PracticePassResult.vue";

@Component({
  components: { Practice, PracticePassResult }
})
export default class PracticeView extends Vue {
  practice!: IPractice;
  _courseId!: string;
  _practiceId!: string;
  course!: ICourse;
  listener!: ICourseListener;
  practicePass!: IPracticePass;
  showSpinner: boolean = false;
  data() {
    return {
      practice: undefined,
      _courseId: undefined,
      _practiceId: undefined,
      course: undefined,
      listener: undefined,
      practicePass: undefined
    };
  }

  get showPracticeForm() {
    return (
      !this.practicePass || this.practicePass.status === "send_to_revision"
    );
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get courseOwner() {
    return this.userId === this.course?.owner?.id;
  }

  get companyOwner() {
    return this.userId === this.course?.company?.owner?.id;
  }

  getListener() {
    api.CourseApi.listenerGetActiveByUser(this.course.id, this.userId)
      .then((res: { data: ICourseListener }) => {
        this.listener = res.data;
        this.checkPracticePass();
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  checkPracticePass() {
    api.PracticeApi.getPassByListener(this.course.id, this.listener.id).then(
      (res: { data: IPracticePass }) => {
        this.practicePass = res.data;
      }
    );
  }

  getPractice() {
    this._courseId = this.$route.params.courseId;
    api.PracticeApi.get(this._courseId).then((res: { data: IPractice }) => {
      this.practice = res.data;
      document.title = this.practice.title;

      if (this.practice) {
        this._practiceId = this.practice.id;
      }
    });

    api.CourseApi.get(this._courseId).then((res: { data: ICourse }) => {
      if (res.data) {
        this.course = res.data;
        this.getListener();
      }
    });
  }

  mounted() {
    this.showSpinner = true;
    this.getPractice();
  }
}
